const _excluded = ["children", "className", "contentClassName", "showFooter", "data-testid", "onClose", "scrollContainerRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import { CloseButton } from "../CloseButton";
import { Typography } from "../Typography";
import styles from "./FullPageModal.module.scss";
const HeaderStartContext = /*#__PURE__*/React.createContext(null);
const HeaderEndContext = /*#__PURE__*/React.createContext(null);
const FooterEndContext = /*#__PURE__*/React.createContext(null);
const FooterStartContext = /*#__PURE__*/React.createContext(null);
const FooterCenterContext = /*#__PURE__*/React.createContext(null);
export function FullPageModal(props) {
  const {
      children,
      className,
      contentClassName,
      showFooter,
      ['data-testid']: testid,
      onClose,
      scrollContainerRef
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [headerStartEl, setHeaderStartEl] = useState(null);
  const [headerEndEl, setHeaderEndEl] = useState(null);
  const [footerStartEl, setFooterStartEl] = useState(null);
  const [footerEndEl, setFooterEndEl] = useState(null);
  const [footerCenterEl, setFooterCenterEl] = useState(null);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.root, className),
    "data-testid": testid
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal",
    ref: setHeaderStartEl,
    "data-testid": testid && testid + '-header-start'
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.headerEnd
  }, /*#__PURE__*/React.createElement("div", {
    ref: setHeaderEndEl
  }), /*#__PURE__*/React.createElement(CloseButton, {
    skin: "transparent",
    "data-testid": testid && testid + '-close-btn',
    onClick: onClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.content, contentClassName),
    ref: scrollContainerRef,
    "data-testid": testid && "".concat(testid, "-content")
  }, /*#__PURE__*/React.createElement(HeaderStartContext.Provider, {
    value: headerStartEl
  }, /*#__PURE__*/React.createElement(HeaderEndContext.Provider, {
    value: headerEndEl
  }, /*#__PURE__*/React.createElement(FooterStartContext.Provider, {
    value: footerStartEl
  }, /*#__PURE__*/React.createElement(FooterEndContext.Provider, {
    value: footerEndEl
  }, /*#__PURE__*/React.createElement(FooterCenterContext.Provider, {
    value: footerCenterEl
  }, children)))))), showFooter && /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    ref: setFooterStartEl
  }), /*#__PURE__*/React.createElement("div", {
    ref: setFooterCenterEl
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.footerEnd,
    ref: setFooterEndEl
  })));
}
const useSlot = (context, children) => {
  const element = useContext(context);
  return element ? /*#__PURE__*/createPortal(children, element) : null;
};
/** Renders its children inside the headerStart slot. */
export const FullPageModalHeaderStart = p => useSlot(HeaderStartContext, p.children);

/** Renders its children inside the headerEnd slot. */
export const FullPageModalHeaderEnd = p => useSlot(HeaderEndContext, p.children);

/** Renders its children inside the footerStart slot. */
export const FullPageModalFooterStart = p => useSlot(FooterStartContext, p.children);

/** Renders its children inside the footerCenter slot. */
export const FullPageModalFooterCenter = p => useSlot(FooterCenterContext, p.children);

/** Renders its children inside the footerEnd slot. */
export const FullPageModalFooterEnd = p => useSlot(FooterEndContext, p.children);
FullPageModal.HeaderStart = FullPageModalHeaderStart;
FullPageModal.HeaderEnd = FullPageModalHeaderEnd;
FullPageModal.FooterStart = FullPageModalFooterStart;
FullPageModal.FooterEnd = FullPageModalFooterEnd;
FullPageModal.FooterCenter = FullPageModalFooterCenter;